export const authSidebarData = [
  {
    id: 1,
    name: "대시보드",
    url: "/",
    subitems: null,
    auth: "dashboard",
  },
  {
    id: 2,
    name: "관리자 관리",
    subitems: [
      {
        id: 1,
        name: "관리자 정보 조회",
        url: "/admin",
        auth: "admin",
      },
    ],
  },
  {
    id: 3,
    name: "사용자 관리",
    subitems: [
      {
        id: 1,
        name: "사용자 정보 조회",
        url: "/user",
        auth: "users",
      },
    ],
  },
  {
    id: 4,
    name: "단말 관리",
    subitems: [
      {
        id: 1,
        name: "단말 조회",
        url: "/device",
        auth: "devices",
      },
    ],
  },
  {
    id: 6,
    name: "이력 관리",
    subitems: [
      {
        id: 1,
        name: "사용자 이력 조회",
        url: "/action/user",
        auth: "admin",
      },
      {
        id: 2,
        name: "단말 이력 조회",
        url: "/action/device",
        auth: "admin",
      },
      {
        id: 3,
        name: "펌웨어 이력 조회",
        url: "/action/firmware",
        auth: "admin",
      },
      {
        id: 4,
        name: "관리자 이력 조회",
        url: "/action/admin",
        auth: "admin",
      },
      {
        id: 5,
        name: "위치정보제공 이력 조회",
        url: "/action/location",
        auth: "admin",
      },
    ],
  },
  {
    id: 7,
    name: "월별 사용 통계",
    url: "/statistics",
    subitems: null,
    auth: "admin",
  },
  {
    id: 8,
    name: "공지사항",
    url: "/notice",
    subitems: null,
    auth: "admin",
  },
];


export const sidebarData = [
  {
    id: 1,
    name: "대시보드",
    url: "/",
    subitems: null,
    auth: "dashboard",
  },
  {
    id: 2,
    name: "관리자 관리",
    subitems: [
      {
        id: 1,
        name: "관리자 정보 조회",
        url: "/admin",
        auth: "admin",
      },
    ],
  },
  {
    id: 3,
    name: "사용자 관리",
    subitems: [
      {
        id: 1,
        name: "사용자 정보 조회",
        url: "/user",
        auth: "users",
      },
    ],
  },
  {
    id: 4,
    name: "단말 관리",
    subitems: [
      {
        id: 1,
        name: "단말 조회",
        url: "/device",
        auth: "devices",
      },
    ],
  },
  {
    id: 6,
    name: "이력 관리",
    subitems: [
      {
        id: 1,
        name: "사용자 이력 조회",
        url: "/action/user",
        auth: "admin",
      },
      {
        id: 2,
        name: "단말 이력 조회",
        url: "/action/device",
        auth: "admin",
      },
      {
        id: 3,
        name: "펌웨어 이력 조회",
        url: "/action/firmware",
        auth: "admin",
      },
      {
        id: 4,
        name: "관리자 이력 조회",
        url: "/action/admin",
        auth: "admin",
      },
    ],
  },
  {
    id: 7,
    name: "월별 사용 통계",
    url: "/statistics",
    subitems: null,
    auth: "admin",
  },
  {
    id: 8,
    name: "공지사항",
    url: "/notice",
    subitems: null,
    auth: "admin",
  },
];
